// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".90df058cc50183a0dada8a00e2651c7a.js";
};